import axios from 'axios';
import { qpSerializer } from '@/utility';
import { setupCache, buildMemoryStorage, defaultKeyGenerator } from 'axios-cache-interceptor';
import config from '../../config';
import interceptors from './interceptors';
import cloudflareInterceptor from './interceptors/cloudflare';

const { api, isCloudflareActive } = config;

const TTL_10_MINUTES = 10 * 60 * 1000;

const http = setupCache(
  axios.create({
    baseURL: api.casino,
    timeout: 10000,
    paramsSerializer: qpSerializer.encode,
  }),

  {
    ttl: TTL_10_MINUTES,
    methods: ['get'],
    storage: buildMemoryStorage(),
    generateKey: defaultKeyGenerator,
  },
);

http.interceptors.request.use(interceptors.requestInterceptor, (error) => Promise.reject(error));

if (isCloudflareActive) {
  http.interceptors.request.use(
    (requestConfig) => cloudflareInterceptor(requestConfig, api.casinoCF),
    (error) => Promise.reject(error),
  );
}

export default http;
